export default __webpack_public_path__ + "static/media/plus.b162b9db.svg";